import React, { useMemo } from 'react';
import { Route, AGENT_CONSOLE_ROUTES, State as RouteState } from 'config/routes';
import { useLocale } from 'locale';
import { State } from 'store/state';
import { routeSelector } from 'store/state/selectors/router';
import { connect } from 'react-redux';
import { publicOfficePageDataSelector } from 'store/state/domainData/selectors/officeById';
import { publicAgentPageDataSelector } from 'store/state/domainData/selectors/agentById';
import { agentIdSelector, managedOfficeSelector } from 'store/state/domainData/selectors';
import { IOfficePageData, IPublicRealEstateAgent } from 'utils/entities';
import Breadcrumbs from 'components/breadcrumbs';

interface BreadcrumbsProps {
  route: RouteState;
  ownAgentId: string;
  officeData: IOfficePageData;
  agentData: IPublicRealEstateAgent;
  managedOfficeId: string;
}

const ACBreadcrumbs: React.FC<BreadcrumbsProps> = (props) => {
  const { route, officeData, agentData, ownAgentId, managedOfficeId } = props;
  const { t } = useLocale();

  const isOwnProfile = agentData && agentData.agentId === ownAgentId;

  const items = useMemo(() => [ {
    label: t('navigation.subheader.breadcrumbs.homepage'),
    routeName: Route.AgentConsoleHomePage,
  }, ...(route && AGENT_CONSOLE_ROUTES.has(route.name) && route.name !== Route.AgentConsoleHomePage ? [ {
    label: t('navigation.subheader.breadcrumbs.agentConsolePage', {
      routeName: route.name,
      isOwnProfile,
      agentName: agentData && agentData.name || '',
      officeName: officeData && officeData.officeName || '',
      isManager: Boolean(managedOfficeId),
    }),
    isCurrent: true,
  } ] : []) ], [ t, officeData, agentData, ownAgentId, route, isOwnProfile, managedOfficeId ]);

  return <Breadcrumbs items={items} />;
};

const mapStateToProps = (state: State) => ({
  route: routeSelector(state),
  officeData: publicOfficePageDataSelector(state),
  agentData: publicAgentPageDataSelector(state),
  ownAgentId: agentIdSelector(state),
  managedOfficeId: managedOfficeSelector(state),
});

export default connect(mapStateToProps)(ACBreadcrumbs);
